import React from 'react';

import {
  Avatar,
  Box,
  Divider,
  Flex,
  Link,
  Text,
  Wrap,
  WrapItem,
  Tooltip,
} from '@chakra-ui/react';

import { TiPencil } from 'react-icons/ti';
import { FiPhoneCall } from 'react-icons/fi';
import { BiMessageRoundedDetail } from 'react-icons/bi';
import { FaChevronLeft } from 'react-icons/fa6';

import { truncateString } from '../../utils/helpers';

import { useSelector, useDispatch } from 'react-redux';
import { setMobileView } from '../../redux/actions/responsiveActions';

const UserInfo = () => {
  const dispatch = useDispatch();

  const activeProspect = useSelector((s) => s?.conversation?.activeProspect);
  const mobileView = useSelector((s) => s?.responsive?.mobileView);

  if (activeProspect)
    return (
      <Box pt={5}>
        <Box>
          <Wrap display="flex" alignItems="center" justifyContent="center">
            <WrapItem
              display="flex"
              alignItems="center"
              justifyContent="center"
              mx="auto"
            >
              {!mobileView ? (
                <Avatar
                  name={`${activeProspect?.firstName || 'No'} ${activeProspect?.lastName || 'Name'}`}
                  color="white"
                  size="xl"
                  src={activeProspect?.imageUrl}
                />
              ) : (
                <Flex alignItems="center">
                  <Box
                    mr="3rem"
                    onClick={() => {
                      dispatch(setMobileView('thread'));
                    }}
                  >
                    <Flex alignItems="center">
                      <FaChevronLeft /> Back
                    </Flex>
                  </Box>
                  <Avatar
                    name={`${activeProspect?.firstName || 'No'} ${activeProspect?.lastName || 'Name'}`}
                    color="white"
                    size="xl"
                    src={activeProspect?.imageUrl}
                  />
                </Flex>
              )}
            </WrapItem>
          </Wrap>
        </Box>
        <Box>
          <Flex
            justifyContent="center"
            alignItems="center"
            flexDirection="column"
          >
            <Tooltip
              hasArrow
              label={activeProspect?.fullName || ''}
              aria-label={activeProspect?.fullName || ''}
            >
              <Text as="p" fontSize={18} fontWeight={700} pe={1} py={2}>
                {truncateString(activeProspect?.fullName, 15)}
              </Text>
            </Tooltip>
            <Tooltip
              hasArrow
              label={activeProspect?.currentPosition || ''}
              aria-label={activeProspect?.currentPosition || ''}
            >
              <Text fontSize={10} fontWeight={700}>
                {truncateString(activeProspect?.currentPosition, 15)}
              </Text>
            </Tooltip>
            <Tooltip
              hasArrow
              label={activeProspect?.companyInfo?.companyName || ''}
              aria-label={activeProspect?.companyInfo?.companyName || ''}
            >
              <Text fontSize={14} fontWeight={700}>
                {truncateString(activeProspect?.companyInfo?.companyName, 20)} (
                {`${activeProspect?.companyInfo?.companySizeToFrom?.to}-${activeProspect?.companyInfo?.companySizeToFrom?.from}`}
                )
              </Text>
            </Tooltip>
            <Text fontSize={12} fontWeight={400} color="orange.primary">
              {truncateString(activeProspect?.companyInfo?.companyIndustry, 20)}
            </Text>
          </Flex>
        </Box>
        <Divider
          orientation="vertical"
          height="10px"
          borderBottom="solid 1px #d6d6d6"
        />
      </Box>
    );
};

export default UserInfo;
